module.exports = __webpack_public_path__ + "static/media/team-1.fa17a94f.webp";